import isEqual from 'react-fast-compare';

export default function diff(a, b) {
  if (a instanceof Set || b instanceof Set) {
    const setA = new Set(a);
    const setB = new Set(b);

    return [
      ...[...setA].filter((key) => !setB.has(key)),
      ...[...setB].filter((key) => !setA.has(key)),
    ];
  }

  if (a instanceof Map || b instanceof Map) {
    const mapA = new Map(a);
    const mapB = new Map(b);

    return [
      ...[...mapA].filter(([key]) => !isEqual(mapA.get(key), mapB.get(key))),
      ...[...mapB].filter(([key]) => !isEqual(mapA.get(key), mapB.get(key))),
    ].reduce(
      (o, [key]) => ({
        ...o,
        [key]: b.get(key),
      }),
      {}
    );
  }

  const objA = a ?? {};
  const objB = b ?? {};

  return [
    ...Object.keys(objA).filter((key) => !isEqual(objA[key], objB[key])),
    ...Object.keys(objB).filter((key) => !isEqual(objA[key], objB[key])),
  ].reduce(
    (o, key) => ({
      ...o,
      [key]: b[key],
    }),
    {}
  );
}
